import React, { useState, useEffect } from 'react';
import axios from 'axios';
import CreateProductModal from '../components/product/CreateProduct';
import DeleteProductModal from '../components/product/DeleteProduct';
import DetailProductModal from '../components/product/DetailProduct';
import UpdateProductModal from '../components/product/UpdateProduct';
import ControlCategory from '../components/product/ControlCategory';

export default function ProductManagement() {
    const [products, setProducts] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [filterCategory, setFilterCategory] = useState(''); // Filtro por categoria
    const [categories, setCategories] = useState([]); // Estado para armazenar as categorias
    const [sortOption, setSortOption] = useState(''); // Opção de ordenação
    const productsPerPage = 12;

    const [isModalDetailOpen, setIsModalDetailOpen] = useState(false);
    const [isModalCreateOpen, setIsModalCreateOpen] = useState(false);
    const [isModalDeleteOpen, setIsModalDeleteOpen] = useState(false);
    const [isModalUpdateOpen, setIsModalUpdateOpen] = useState(false);
    const [isModalCategoryOpen, setIsModalCategoryOpen] = useState(false);

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL || "https://api.clelton-churrasqueiras.site"}/productRoutes/product`);
                if (Array.isArray(response.data)) {
                    setProducts(response.data);
                    setFilteredProducts(response.data);
                } else {
                    console.error('Erro: dados de produtos não são um array.');
                }
            } catch (error) {
                console.error('Erro ao buscar produtos:', error);
            }
        };

        loadCategories();
        fetchProducts();
    }, []);

    const fetchProducts = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL || "https://api.clelton-churrasqueiras.site"}/productRoutes/product`);
            if (Array.isArray(response.data)) {
                setProducts(response.data);
                setFilteredProducts(response.data);
            } else {
                console.error('Erro: dados de produtos não são um array.');
            }
        } catch (error) {
            console.error('Error fetching products:', error);
        }
    };

    // Função para carregar as categorias
    const loadCategories = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL || "https://api.clelton-churrasqueiras.site"}/categoryRoutes/category`);
            setCategories(response.data);
        } catch (error) {
            console.error('Erro ao carregar as categorias', error);
        }
    };

    const handleUpdateProduct = async (updatedProductData) => {
        try {
            const response = await axios.put(`${process.env.REACT_APP_API_URL || "https://api.clelton-churrasqueiras.site"}/productRoutes/product/${updatedProductData.id}`, updatedProductData, {
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    });

            if (response && response.data) {
                setProducts((prevProducts) => {
                    const index = prevProducts.findIndex((product) => product.id === updatedProductData.id);

                    if (index !== -1) {
                        const updatedProducts = [...prevProducts];
                        updatedProducts[index] = response.data;
                        filterAndSortProducts(updatedProducts, searchTerm, filterCategory, sortOption);
                        return updatedProducts;
                    }

                    return prevProducts;
                });

                setFilteredProducts((prevProducts) => {
                    return prevProducts.map((product) =>
                        product.id === updatedProductData.id ? response.data : product
                    );
                });

                setIsModalUpdateOpen(false);
            } else {
                console.error('Erro: resposta da API não contém os dados atualizados.');
            }
        } catch (error) {
            console.error('Erro ao atualizar produto:', error);
        }
    };

    const handleSelectProductForUpdate = (product) => {
        setSelectedProduct(product);
        setIsModalUpdateOpen(true);
    };

    const handleSearch = (e) => {
        const term = e.target.value.toLowerCase();
        setSearchTerm(term);
        filterAndSortProducts(products, term, filterCategory, sortOption);
        setCurrentPage(1);
    };

    const handleFilterCategory = (e) => {
        const category = e.target.value;
        setFilterCategory(category);
        filterAndSortProducts(products, searchTerm, category, sortOption);
    };

    const handleSortChange = (e) => {
        const option = e.target.value;
        setSortOption(option);
        filterAndSortProducts(products, searchTerm, filterCategory, option);
    };

    const filterAndSortProducts = (products, searchTerm, category, sortOption) => {
        let filtered = products;

        // Filtrar por nome
        if (searchTerm) {
            filtered = filtered.filter((product) =>
                product.nome.toLowerCase().includes(searchTerm)
            );
        }

        // Filtrar por categoria
        if (category) {
            filtered = filtered.filter((product) => product.categoria === category);
        }

        // Ordenar os resultados
        if (sortOption === 'priceCrescente') {
            filtered = filtered.sort((a, b) => a.valor - b.valor);
        } else if (sortOption === 'priceDecrescente') {
            filtered = filtered.sort((a, b) => b.valor - a.valor);
        } else if (sortOption === 'idCrescente') {
            filtered = filtered.sort((a, b) => a.id - b.id);
        } else if (sortOption === 'idDecrescente') {
            filtered = filtered.sort((a, b) => b.id - a.id);
        }

        setFilteredProducts(filtered);
    };

    const handleSelectProduct = (product) => {
        setSelectedProduct(product);
        setIsModalDetailOpen(true);
    };

    const handleDeleteProduct = (product) => {
        setSelectedProduct(product);
        setIsModalDeleteOpen(true);
    };

    const handleOpenCreateModal = () => setIsModalCreateOpen(true);
    const handleCloseCreateModal = () => setIsModalCreateOpen(false);
    const handleCloseDetailModal = () => setIsModalDetailOpen(false);
    const handleCloseDeleteModal = () => setIsModalDeleteOpen(false);
    const handleCloseUpdateModal = () => setIsModalUpdateOpen(false);
    const handleOpenCategoryModal = () => setIsModalCategoryOpen(true);
    const handleCloseCategoryModal = () => setIsModalCategoryOpen(false);

    const indexOfLastProduct = currentPage * productsPerPage;
    const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
    const currentProducts = filteredProducts.slice(indexOfFirstProduct, indexOfLastProduct);

    const totalPages = Math.ceil(filteredProducts.length / productsPerPage);

    const goToPage = (page) => setCurrentPage(page);

    const formatarParaBRL = (valor)  => {
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        }).format(valor);
    }

    return (
        <div className="p-4 md:p-8 animate-fade-in max-w-7xl mx-auto">
            <div className="flex flex-col mb-8">
                <h1 className="text-3xl font-serif text-white font-bold tracking-wide">Gerenciamento de Produtos</h1>
                <p className="text-gray-400 mt-2 text-sm">Controle de estoque, preços e categorias</p>
            </div>

            <div className="glass-panel p-6 mb-8">
                <div className="flex flex-col md:flex-row justify-between items-center gap-4">
                    <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4 w-full md:w-auto">
                        <input
                            type="text"
                            placeholder="Buscar produtos..."
                            value={searchTerm}
                            onChange={handleSearch}
                            className="glass-input w-full md:w-64"
                        />

                        <select
                            value={filterCategory}
                            onChange={handleFilterCategory}
                            className="glass-input w-full md:w-48 appearance-none bg-background-darker"
                        >
                            <option value="">Filtrar por Categoria</option>
                            {categories.map((category) => (
                                <option key={category.id} value={category.nome}>
                                    {category.nome}
                                </option>
                            ))}
                        </select>

                        <select
                            value={sortOption}
                            onChange={handleSortChange}
                            className="glass-input w-full md:w-48 appearance-none bg-background-darker"
                        >
                            <option value="">Ordenar</option>
                            <option value="priceCrescente">Valor (Crescente)</option>
                            <option value="priceDecrescente">Valor (Decrescente)</option>
                            <option value="idCrescente">Produto mais antigo</option>
                            <option value="idDecrescente">Produto mais novo</option>
                        </select>
                    </div>

                    <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4 w-full md:w-auto">
                        <button
                            onClick={handleOpenCategoryModal}
                            className="glass-button w-full md:w-auto flex items-center justify-center bg-blue-600/80 hover:bg-blue-600"
                        >
                            <span className="text-xl mr-2">+</span> Categoria
                        </button>
                        <button
                            onClick={handleOpenCreateModal}
                            className="glass-button w-full md:w-auto flex items-center justify-center"
                        >
                            <span className="text-xl mr-2">+</span> Produto
                        </button>
                    </div>
                </div>
            </div>

            <div className="glass-panel overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="glass-table">
                        <thead>
                        <tr>
                            <th>ID</th>
                            <th className="w-1/4">Nome</th>
                            <th className="w-1/4">Categoria</th>
                            <th>Valor</th>
                            <th>Valor de Venda</th>
                            <th className="text-center">Ações</th>
                        </tr>
                        </thead>
                        <tbody className="text-gray-200 text-sm">
                        {currentProducts.map((product) => (
                            <tr key={product.id}>
                                <td>{product.id}</td>
                                <td className="font-medium text-white">{product.nome}</td>
                                <td>
                                    <span className="bg-white/10 px-3 py-1 rounded-full text-xs border border-white/5">
                                        {product.categoria}
                                    </span>
                                </td>
                                <td>{formatarParaBRL(product.valor)}</td>
                                <td className="font-semibold text-green-400">{formatarParaBRL(product.valor_venda)}</td>
                                <td>
                                    <div className="flex justify-center space-x-2">
                                        <button
                                            onClick={() => handleSelectProduct(product)}
                                            className="text-blue-400 hover:text-blue-300 p-2 rounded-lg hover:bg-blue-400/10 transition-colors"
                                            title="Detalhes"
                                        >
                                            Detalhes
                                        </button>
                                        <button
                                            onClick={() => handleSelectProductForUpdate(product)}
                                            className="text-amber-400 hover:text-amber-300 p-2 rounded-lg hover:bg-amber-400/10 transition-colors"
                                            title="Atualizar"
                                        >
                                            Editar
                                        </button>
                                        <button
                                            onClick={() => handleDeleteProduct(product)}
                                            className="text-red-400 hover:text-red-300 p-2 rounded-lg hover:bg-red-400/10 transition-colors"
                                            title="Excluir"
                                        >
                                            Excluir
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="flex justify-center items-center mt-8 space-x-2 pb-8">
                {Array.from({ length: totalPages }, (_, index) => (
                    <button
                        key={index}
                        onClick={() => goToPage(index + 1)}
                        className={`w-10 h-10 rounded-full flex items-center justify-center font-medium transition-all ${
                            currentPage === index + 1
                                ? 'bg-primary text-white shadow-lg border border-primary/50'
                                : 'bg-white/5 text-gray-400 hover:bg-white/10 border border-white/5 hover:text-white'
                        }`}
                    >
                        {index + 1}
                    </button>
                ))}
            </div>

            {/* Modal de Cadastro */}
            {isModalCreateOpen && (
                <CreateProductModal onClose={handleCloseCreateModal} onUpdateScreen={fetchProducts} />
            )}

            {/* Modal de Detalhe */}
            {isModalDetailOpen && (
                <DetailProductModal
                    onClose={handleCloseDetailModal}
                    product={selectedProduct}
                    onUpdateScreen={fetchProducts}
                />
            )}

            {/* Modal de Exclusão */}
            {isModalDeleteOpen && (
                <DeleteProductModal
                    onClose={handleCloseDeleteModal}
                    product={selectedProduct}
                    onUpdateScreen={fetchProducts}
                />
            )}

            {/* Modal de Atualização */}
            {isModalUpdateOpen && (
                <UpdateProductModal
                    product={selectedProduct}
                    onClose={handleCloseUpdateModal}
                    onUpdateProduct={handleUpdateProduct}
                />
            )}

            {/* Modal de Categoria */}
            {isModalCategoryOpen && (
                <ControlCategory
                    onUpdateScreen={loadCategories}
                    onClose={handleCloseCategoryModal}
                    onCategoryAction={handleOpenCategoryModal}
                />
            )}
        </div>
    );
}
